import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

import FeeForm from "apps/fees/Fee/FeeForm"
import { reverse } from "utils/urls"

export default function AirlineFeeUpdate(props) {
  const { t } = useTranslation()

  return (
    <FeeForm
      {...props}
      isUpdate
      detailEndpoint={`/fees/airline-fees/${props.match.params.id}/`}
      actionEndpoint={`/fees/airline-fees/${props.match.params.id}/`}
      errorUrl={reverse("airlineFeeList")}
      label={t("Edit airline fee")}
      successMessage={t("Airline Fee was successfully saved.")}
      successUrl={reverse("airlineFeeList")}
    />
  )
}

AirlineFeeUpdate.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
